export default __webpack_public_path__ + "static/media/bathroom2-afterA-1440w.12b908fe.png";